module.exports = __webpack_public_path__ + "static/media/vehicle_documentation_back.174c5906.svg";